import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46809116"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controls-grid" }
const _hoisted_2 = { class: "left-col" }
const _hoisted_3 = { class: "top-selects" }
const _hoisted_4 = ["selected"]
const _hoisted_5 = ["disabled", "value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "week-range-group"
}
const _hoisted_8 = ["disabled", "value"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["disabled", "value"]
const _hoisted_11 = { class: "avg-perc" }
const _hoisted_12 = { class: "right-col" }
const _hoisted_13 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "component-wrapper"
}

import {nextTick, ref, shallowRef, watch} from 'vue'
import MyTable from './MyTable.vue';
import MyBracket from './MyBracket.vue';
import MyDraft from './MyDraft.vue';

import { onMounted } from 'vue'
import ffWebsiteAPI from "@/services/ff-website-api";
// import ffWebsiteAPI from '../../services/ff-website-api'

interface selectdataInfo {
    select: string,
}

interface settingsInfo {
    season: string,
    playoff_week_start: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MyLeaderboard',
  setup(__props) {


onMounted(() => {
  ffWebsiteAPI.ready = new Promise(resolve => {
      ffWebsiteAPI.resolver = resolve;
  });
  fetchSettings();
  ffWebsiteAPI.resolver(1)
  console.log("Leaderboard is mounted")
});

const tables = [
  { name: 'MyTable', comp: MyTable },
  { name: 'MyDraft', comp: MyDraft },
  { name: 'MyBracket', comp: MyBracket },
]

const loading = ref(false);

const per = ref(false)
const ppg = ref(false)

const currentYear = ref("Year:");
const currentStat = ref("Regular Season");
const playoffWeek = ref(0);
const maxHighWeek = ref(17);
const currentLowWeek = ref(1);
const currentHighWeek = ref(14);

let currentTable = shallowRef(tables[0]);

let avg = shallowRef('Total Points');
let perc = shallowRef('Record');

let yearoptions = ref<Array<selectdataInfo | null>>([{select: "All Time"}])
let weekoptions = ref<Array<selectdataInfo | null>>([])

let seasonsettings = new Map<string, settingsInfo>()

let statsoptions: Array<selectdataInfo> = [
  {select: "Regular Season"},
  {select: "Postseason"},
  {select: "Combined"}
]

async function fetchSettings() {
    loading.value = true;
    try {
      //yearoptions.value.push({select: "2019"})
      const response = await ffWebsiteAPI.getSettings(currentYear.value);
      for (let i=0; i<response.length; i++) {
        seasonsettings.set(response[i].season, response[i])
      }
      seasonsettings.forEach((value: settingsInfo, key: string) => {
        yearoptions.value.push({select: key})
      });

      await nextTick()
      //console.log(tabledata.value)
    }
    catch (e) {
      console.log(e)
    }
    finally {
      loading.value = false;
    }
}

async function getSeasonSettings(year: string) {
      weekoptions.value = [];
      playoffWeek.value = seasonsettings.get(year).playoff_week_start;

      for (let i=0; i<playoffWeek.value+2; i++) {
        weekoptions.value.push({select: (i + 1).toString()})
      }
      await nextTick()
}

function updateValues(payload: { stat?: string; lowerWeek?: number; higherWeek?: number; maxHighWeek?: number }) {
  if (payload.stat !== undefined) currentStat.value = payload.stat;
  if (payload.lowerWeek !== undefined) currentLowWeek.value = payload.lowerWeek;
  if (payload.higherWeek !== undefined) currentHighWeek.value = payload.higherWeek;
  if (payload.maxHighWeek !== undefined) maxHighWeek.value = payload.maxHighWeek;
}

watch(() => currentYear.value, (newYear) => {
  if (!(newYear == 'Year:' || newYear == 'All Time')) {
    getSeasonSettings(newYear);
  }
})

function goBack() {
  currentTable.value = tables[0];
}

function changePerc(event: Event) {
  const target = event.target as HTMLButtonElement;
  if (target != null) {
    target.disabled = true
    if (per.value == true) {
      per.value = false
      perc.value = "Record";
    }
    else {
      per.value = true
      perc.value = "Winning %";
    }
    target.disabled = false
  }
}

function changeAvg(event: Event) {
  const target = event.target as HTMLButtonElement;
  if (target != null) {
    target.disabled = true
    if (ppg.value == true) {
      ppg.value = false
      avg.value = "Total Points";
    }
    else {
      ppg.value = true
      avg.value = "Points Per Game";
    }
    target.disabled = false
  }
}

function showBrac() {
  currentTable.value = tables[2];
}

function showDraft() {
  currentTable.value = tables[1];
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentYear).value = $event)),
            name: "year",
            id: "year"
          }, [
            _createElementVNode("option", {
              disabled: "",
              selected: currentYear.value == 'Year:'
            }, "Year:", 8, _hoisted_4),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearoptions), (year) => {
              return (_openBlock(), _createElementBlock("option", {
                disabled: (_unref(currentTable).comp == MyDraft || _unref(currentTable).comp == MyBracket) && (year.select =='All Time'),
                value: year.select,
                key: year.select
              }, _toDisplayString(year.select), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, currentYear.value]
          ]),
          (_unref(currentTable).comp == MyTable)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentStat).value = $event)),
                name: "stat",
                id: "stat"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statsoptions), (stats) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: stats.select,
                    key: stats.select
                  }, _toDisplayString(stats.select), 9, _hoisted_6))
                }), 128))
              ], 512)), [
                [_vModelSelect, currentStat.value]
              ])
            : _createCommentVNode("", true)
        ]),
        (_unref(currentTable).comp == MyTable && !(currentYear.value =='All Time' || currentYear.value =='Year:'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentLowWeek).value = $event)),
                name: "week",
                id: "week"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weekoptions), (week) => {
                  return (_openBlock(), _createElementBlock("option", {
                    disabled: Number(week.select) >= Number(currentHighWeek.value) || (Number(week.select) > maxHighWeek.value && Number(week.select) < 100),
                    value: week.select,
                    key: week.select
                  }, "Week " + _toDisplayString(week.select), 9, _hoisted_8))
                }), 128))
              ], 512), [
                [_vModelSelect, currentLowWeek.value]
              ]),
              (currentHighWeek.value!=100)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentHighWeek).value = $event)),
                class: _normalizeClass({ 'same-week': Number(currentHighWeek.value) === 100 }),
                name: "week",
                id: "week"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weekoptions), (week) => {
                  return (_openBlock(), _createElementBlock("option", {
                    disabled: Number(week.select) < currentLowWeek.value || (Number(week.select) > maxHighWeek.value && Number(week.select) < 100),
                    value: (week.select != currentLowWeek.value) ? week.select : 100,
                    key: week.select
                  }, "Week " + _toDisplayString(week.select), 9, _hoisted_10))
                }), 128))
              ], 2), [
                [_vModelSelect, currentHighWeek.value]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          (_unref(currentTable).comp == MyTable)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                id: "avg",
                name: "avg",
                class: "btn btn-secondary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (changeAvg($event)))
              }, _toDisplayString(_unref(avg)), 1))
            : _createCommentVNode("", true),
          (_unref(currentTable).comp == MyTable)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                id: "perc",
                name: "perc",
                class: "btn btn-secondary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (changePerc($event)))
              }, _toDisplayString(_unref(perc)), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_unref(currentTable).comp == MyDraft)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "brac",
              name: "back",
              class: "btn btn-light",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (goBack()))
            }, "Back"))
          : _createCommentVNode("", true),
        (currentYear.value != 'Year:' && currentYear.value != 'All Time' && _unref(currentTable).comp != MyDraft)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              id: "draft",
              name: "draft",
              class: "btn btn-light",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (showDraft()))
            }, "Draft Recap"))
          : _createCommentVNode("", true),
        (currentYear.value != 'Year:' && currentYear.value != 'All Time' && _unref(currentTable).comp != MyBracket)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              id: "brac",
              name: "brac",
              class: "btn btn-light",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (showBrac()))
            }, "Playoff Bracket"))
          : _createCommentVNode("", true),
        (_unref(currentTable).comp == MyBracket)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              id: "brac",
              name: "back",
              class: "btn btn-light",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (goBack()))
            }, "Back"))
          : _createCommentVNode("", true)
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentTable).comp), {
            year: currentYear.value,
            lowerWeek: currentLowWeek.value,
            higherWeek: currentHighWeek.value,
            playoffWeek: playoffWeek.value,
            maxHighWeek: maxHighWeek.value,
            stat: currentStat.value,
            ppg: ppg.value,
            per: per.value,
            onUpdateValues: updateValues
          }, null, 40, ["year", "lowerWeek", "higherWeek", "playoffWeek", "maxHighWeek", "stat", "ppg", "per"]))
        ]))
  ], 64))
}
}

})